import React from 'react';
import '../support/styles.css';
import './styles.css';

export interface InviteMessageLink {
    title: string;
    href: string;
}

export interface InviteMessageProps {
    title: string;
    message?: string;
    link?: InviteMessageLink;
}

export const InviteMessage = ({ title, message, link }: InviteMessageProps) => (
    <div className="support-form">
        <div className="survey-success">
            <p>{title}</p>
            {message && <p className="invite-not-found-sub">{message}</p>}
            {link && (
                <a className="support-success-link" href={link.href}>
                    {link.title}
                </a>
            )}
        </div>
    </div>
);

export default InviteMessage;
